/****
 *
 * 全局混入对象
 *
 *
 */

//工具类方法函数
import Tool from "./tool.mixin";
import { user } from '@/assets/js/api.url.js';

export default {
  mounted() {
    //在组件内 methods 中添加 langSetCallback 函数，用于响应全局语言变换的自动触发
    if (typeof this.langSetCallback === "function") {
      this.$bus.on("langSetCallback", this.langSetCallback);
    }
    //在组件内 methods 中添加 selectCompanyCall 函数，用于响应全局计价单位变换的自动触发
    if (typeof this.selectCompanyCall === "function") {
      this.$bus.on("selectCompanyCall", this.selectCompanyCall);
    }
  },

  methods: {
    GlobalGetUserStatus() {
      if (!localStorage.getItem('x-token')) return {
        data: {id: null}
      }
      let userInfoUrl = user.topsInfo2;

      // h5 请求设置cookie 和 sid参数
      let url = window.location.href;
      let sid;
      if (url.indexOf("h5") > -1) {
        let _sid = localStorage.getItem("sid");
        sid = this.$route.query.sid;
        console.log("_sid", _sid, "sid", sid);
        if (sid) {
          console.log("路由sid", sid);
          localStorage.setItem("sid", sid);
        } else {
          sid = _sid;
          console.log("localstoresid", sid);
        }
      }
      if (sid != "" && sid != undefined) {
        userInfoUrl += "?sid=" + sid;
        this.setCookie("sid", sid);
        return this.get(userInfoUrl);
      } else {
        this.setCookie("sid", "");
      }

      return this.get(userInfoUrl);
    },
    async GlobalGetUserInfo() {
      if (!localStorage.getItem('x-token')) return
      let res = await this.GlobalGetUserStatus();
      this.$store.dispatch("getUserMenu", res.data);
      if (res.code == 0 && res.data.id) {
        let _res = this.post(user.topsInfo,{},
          { headers: { "x-user-id": res.data.id } }
        )
        console.log("GlobalGetUserInfo=========设置用户登录信息==========", _res);
            
        return _res;
      } else {
        console.warn("未登录");
        return res;
      }
    },
    ...Tool.methods,
  },
};



// WEBPACK FOOTER //
// ./src/mixins/app.mixin.js